<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<g>
			<path
				d="M13.3331 14.7061H18.3331"
				stroke="currentColor"
				stroke-width="1.61616"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M13.3331 1.37268V3.87268"
				stroke="currentColor"
				stroke-width="1.61616"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M15.8331 12.2061V17.2061"
				stroke="currentColor"
				stroke-width="1.61616"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M17.5 9.28945V3.87278C17.5 3.43075 17.3244 3.00683 17.0118 2.69427C16.6993 2.38171 16.2754 2.20612 15.8333 2.20612H4.16667C3.72464 2.20612 3.30072 2.38171 2.98816 2.69427C2.67559 3.00683 2.5 3.43075 2.5 3.87278V15.5394C2.5 15.9815 2.67559 16.4054 2.98816 16.718C3.30072 17.0305 3.72464 17.2061 4.16667 17.2061H11.0833"
				stroke="currentColor"
				stroke-width="1.61616"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M2.5 7.20612H17.5"
				stroke="currentColor"
				stroke-width="1.61616"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M6.66687 1.37268V3.87268"
				stroke="currentColor"
				stroke-width="1.61616"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'IconCalendarPlus',
	props: { size: { type: [Number, String], default: 20 } }
}
</script>
